import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@material-ui/core";
import Button from "@material-ui/core/Button";

export default function DeletePrompt({open,loading=false,onClose,onConfirm}) {
    const handleClose = () => {
        onClose && onClose()
    };

    const handleConfirmation = () => {
        onConfirm && onConfirm()
        handleClose()
    };

    return (
        <div>

            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle >{"Attention!"}</DialogTitle>
                <DialogContent>
                    <DialogContentText  color={"error"}>
                        Êtes-vous sûr de vouloir supprimer ?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary" autoFocus>
                        non
                    </Button>
                    <Button onClick={handleConfirmation}  >
                        Oui
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}